import React, { type ReactHTML, useMemo } from 'react';

const LINK_RE = /<a([^<>]*)(?<!tabindex=[^<>]*)>/gi;

const linkReplacement = ($0, $1) => `<a${$1} tabindex="0">`;

type TProps = {
  className?: string;
  content: string;
  id?: string;
  node?: keyof ReactHTML;
};

const HtmlContent = React.memo(({ className, content, id, node: Node = 'div' }: TProps) => {
  const modifiedContent = useMemo(() => content?.replace(LINK_RE, linkReplacement), [content]);

  return <Node className={className} dangerouslySetInnerHTML={{ __html: modifiedContent }} id={id} />;
});

HtmlContent.displayName = 'HtmlContent';

export default HtmlContent;
